import { Unit, UNIT_LABEL } from '../core/units';

/** Untere Leiste: Kontexttipp links, Maßkasten (VCB) + Einheiten rechts. */
export class StatusBar {
  el: HTMLElement;
  private hintEl: HTMLElement;
  private vcbEl: HTMLElement;
  private defaultHint = '';
  private unitsSel!: HTMLSelectElement;

  constructor(root: HTMLElement, units: Unit, onUnitsChange: (u: Unit) => void) {
    this.el = document.createElement('div');
    this.el.className = 'statusbar';
    this.hintEl = document.createElement('div');
    this.hintEl.className = 'statusbar-hint';

    const right = document.createElement('div');
    right.className = 'statusbar-right';

    const vcbLabel = document.createElement('span');
    vcbLabel.className = 'vcb-label';
    vcbLabel.textContent = 'Maßkasten';
    this.vcbEl = document.createElement('div');
    this.vcbEl.className = 'vcb';
    this.vcbEl.textContent = '';

    const unitsSel = document.createElement('select');
    unitsSel.className = 'units-select';
    unitsSel.title = 'Einheit';
    for (const u of ['mm', 'cm', 'm'] as Unit[]) {
      const opt = document.createElement('option');
      opt.value = u;
      opt.textContent = UNIT_LABEL[u];
      if (u === units) opt.selected = true;
      unitsSel.appendChild(opt);
    }
    unitsSel.onchange = () => {
      onUnitsChange(unitsSel.value as Unit);
      unitsSel.blur(); // Fokus zurück, sonst landen Tastenkürzel im Auswahlfeld
    };
    this.unitsSel = unitsSel;

    right.append(vcbLabel, this.vcbEl, unitsSel);
    this.el.append(this.hintEl, right);
    root.appendChild(this.el);
  }

  /** Einheit von außen setzen (z. B. nach Laden eines Projekts). */
  setUnits(u: Unit): void {
    this.unitsSel.value = u;
  }

  /** null = Standardtipp des Werkzeugs wieder anzeigen. */
  setStatus(hint: string | null): void {
    this.hintEl.textContent = hint ?? this.defaultHint;
  }

  setDefaultHint(text: string): void {
    this.defaultHint = text;
    if (!this.hintEl.dataset.overridden) this.setStatus(null);
  }

  /** Aktuelle Anzeige des Maßkastens (live-Wert oder getippte Zahl). */
  setVcb(text: string | null, typed = false): void {
    this.vcbEl.textContent = text ?? '';
    this.vcbEl.classList.toggle('vcb-typed', typed);
  }
}
